/**
 * @module Utilities/Locales
 * @desc Locales helper funtions
 */

import type { Locales } from 'config';

/**
 * Get the IETF code for a locale
 * @see https://www.loc.gov/standards/iso639-2/php/code_list.php // TROCA
 * @see https://www.nationsonline.org/oneworld/country_code_list.htm // TROCA
 * acronyms:
 * lc (language code)
 * cc (country code)
 */
export function getLanguageTag(locale: Locales, format = 'lc-CC') {
  const localeMap = {
    pt: ['pt', 'BR'],
    es: ['es', 'MX'],
    en: ['en', 'US'],
  };

  const [lc, cc] = localeMap[locale] || localeMap.pt;

  if (format === 'lc_cc') {
    return `${lc}_${cc.toLowerCase()}`;
  }

  return `${lc}-${cc}`;
}
